import { createSelector } from 'reselect'
import { chain, pick } from 'lodash'
import { STATUS_CANCELLED } from 'constants/orderStatuses'
import { sdkDateToSystemDateTime } from 'utilities/DateUtils/dateUtils'

/**
 * @deprecated
 */
export const selectOrdersById = (state) => state.resources.OrdersReducer.byId

/**
 * @deprecated
 */
const selectBookingOrderItemsById = (state) => {
  return Object.keys(state.resources.BookingOrderItemsReducer.byId ?? {}).reduce(
    (itemsById, key) => {
      const item = state.resources.BookingOrderItemsReducer.byId[key]

      // Convert all date-only values to the system timezone before returning them
      itemsById[key] = {
        ...item,
        date: item.date ? sdkDateToSystemDateTime(item.date).toJSDate() : item.date,
      }

      return itemsById
    },
    {}
  )
}

/**
 * @deprecated
 */
const selectPackageOrderItemsById = (state) => state.resources.PackageOrderItemsReducer.byId || {}

/**
 * @deprecated
 */
const selectPurchaseOrderItemsReducer = (state) => state.resources.PurchaseOrderItemsReducer

/**
 * @deprecated
 */
const selectPractitionerSummariesReducer = (state) => state.resources.PractitionerSummariesReducer

/**
 * @deprecated
 */
export const selectOrder = (orderId) =>
  createSelector([selectOrdersById], (byId = {}) => byId[orderId])

/**
 * @deprecated
 */
export const selectPackageOrderItemsIds = (orderId) =>
  createSelector([selectOrdersById], (ordersById = {}) => {
    const { package_items: packageItemIds = [] } = ordersById[orderId] || {
      package_items: [],
    }

    return packageItemIds
  })

/**
 * @deprecated
 */
export const selectBookingOrderItem = (orderItemId) =>
  createSelector([selectBookingOrderItemsById], (byId) => byId[orderItemId] || {})

/**
 * @deprecated
 */
export const selectPackageOrderItem = (orderItemId) =>
  createSelector([selectPackageOrderItemsById], (byId) => byId[orderItemId] || {})

/**
 * @deprecated
 */
export const selectPractitionerSummary = (practitionerId) =>
  createSelector(
    [selectPractitionerSummariesReducer, () => practitionerId],
    ({ byId }, practitionerId) => byId[practitionerId] || {}
  )

/**
 * @deprecated
 */
export const selectPurchaseOrderItem = (orderItemId) =>
  createSelector(
    [selectPurchaseOrderItemsReducer, () => orderItemId],
    ({ byId }, orderItemId) => byId[orderItemId] || {}
  )

/**
 * @deprecated
 */
export const selectAllActiveOrderItemDates = (basketId) =>
  createSelector(
    [selectActiveBookingOrderItemDates(basketId), selectAllActivePackageOrderItemDates(basketId)],
    (bookingDates = [], packageDates = []) =>
      chain(bookingDates)
        .concat(packageDates)
        .uniqBy((date) => date.getTime())
        .sortBy((date) => date.getTime())
        .value()
  )

/**
 * @deprecated
 */
const selectActiveBookingOrderItemDates = (basketId) =>
  createSelector([selectOrderBookingOrderItems(basketId)], (items = []) =>
    chain(items)
      .filter(({ status }) => status !== STATUS_CANCELLED)
      .map((item) => item.date)
      .filter()
      .uniqBy((date) => date.getTime())
      .sortBy((date) => date.getTime())

      .value()
  )

/**
 * @deprecated
 */
const selectOrderBookingOrderItems = (orderId) =>
  createSelector(
    [selectOrdersById, selectBookingOrderItemsById],
    (ordersById = {}, itemsById = {}) => {
      const order = ordersById[orderId] || { booking_items: [] }
      const { booking_items: bookingItemIds = [] } = order

      return Object.values(pick(itemsById, bookingItemIds))
    }
  )

/**
 * @deprecated
 */
const selectAllActivePackageOrderItemDates = (orderId) =>
  createSelector(
    [selectPackageOrderItemsIds(orderId), selectPackageOrderItemsById],
    (packageItemIds = [], packageOrderItemsById = {}) => {
      const packageOrderItems = Object.values(pick(packageOrderItemsById, packageItemIds))

      return chain(packageOrderItems)
        .filter(({ status }) => status !== STATUS_CANCELLED)
        .map((item) => item.date)
        .filter()
        .uniqBy((date) => date.getTime())
        .sortBy((date) => date.getTime())
        .value()
    }
  )
